<div class="card card-about bg-dark text-dark">
  <img src="/assets/img/header3.jpg" class="card-img" alt="About the project" />
  <div class="overlay-div"></div>
</div>

<app-info-bar></app-info-bar>

<div class="container mx-auto">
    <div class="row">
      <div class="col-sm">
        <div class="card-body">
          <h3 class="card-title">Location</h3>
          <hr>
          <div class="mapouter">
            <div class="gmap_canvas">
                <iframe class="responsive-iframe"
                    src="https://maps.google.com/maps?q=paldiski%20mnt%2021,%20tallinn&t=&z=13&ie=UTF8&iwloc=&output=embed"
                    frameborder="0"
                    scrolling="no"
                    marginheight="0"
                    marginwidth="0">
                </iframe>
                <br />
            </div>
          </div>
          <hr />
          <h6 class="card-text">Not a real location! Sorry!</h6>
        </div>
      </div>
      <div class="col-sm text-center">
        <div class="card-about">
            <div class="card-body">
                <h3 class="card-title py-3">Contact Us</h3>
                <hr>
                <div class="card-text text-center">
                    <!-- Email -->
                    <a class="btn btn-link btn-floating btn-lg text-dark email px-0"
                        href="mailto:fakeemail@PaikesePizza.com"
                        role="button">
                        <i class="fas fa-envelope"></i>
                        fake@Paikese.com
                    </a>
                    <br>
                    <!-- Phone -->
                    <p class="btn btn-link btn-floating btn-lg text-dark py-3">
                        <i class="fas fa-phone"></i>
                        +372 5555 9999
                    </p>
                    <hr>
                    <h6 class="card-text py-3">Not a real email or phone number! Sorry!</h6>
                    <!-- <p class="btn btn-link btn-floating btn-lg text-dark m-1">Send a comment</p>
                    <form action="mailto:someone@example.com" method="post" enctype="text/plain">
                        Name: <input type="text" name="name"><br>
                        E-mail: <input type="text" name="mail"><br>
                        Comment:<br>
                        <input type="text" name="comment" size="50"><br><br>
                        <input type="submit" value="Send">
                        <input type="reset" value="Reset">
                    </form> -->
                </div>
            </div>
        </div>
    </div>
</div>


